// Workspace module routes
import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy load pages
const BheemChat = lazy(() => import('./pages/BheemChat'));
const BheemFeed = lazy(() => import('./pages/BheemFeed'));
const BookmarkedPosts = lazy(() => import('./pages/BookmarkedPosts'));
const MyPosts = lazy(() => import('./pages/MyPosts'));

// Loading fallback
const PageLoader = () => (
  <div className="flex items-center justify-center h-full">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500" />
  </div>
);

export const workspaceRoutes: RouteObject[] = [
  // Chat routes
  {
    path: 'bheem-chat',
    element: (
      <Suspense fallback={<PageLoader />}>
        <BheemChat />
      </Suspense>
    ),
  },
  {
    path: 'employee-chat',
    element: (
      <Suspense fallback={<PageLoader />}>
        <BheemChat />
      </Suspense>
    ),
  },
  // Feed routes
  {
    path: 'bheem-feed',
    element: (
      <Suspense fallback={<PageLoader />}>
        <BheemFeed />
      </Suspense>
    ),
  },
  {
    path: 'company-feed',
    element: (
      <Suspense fallback={<PageLoader />}>
        <BheemFeed />
      </Suspense>
    ),
  },
  {
    path: 'feed',
    element: (
      <Suspense fallback={<PageLoader />}>
        <BheemFeed />
      </Suspense>
    ),
  },
  // Feed sub-pages
  {
    path: 'feed/bookmarks',
    element: (
      <Suspense fallback={<PageLoader />}>
        <BookmarkedPosts />
      </Suspense>
    ),
  },
  {
    path: 'feed/my-posts',
    element: (
      <Suspense fallback={<PageLoader />}>
        <MyPosts />
      </Suspense>
    ),
  },
];

export default workspaceRoutes;
